var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-us-container"},[_c('div',{staticClass:"contact-image-container"},[_c('img',{staticClass:"contact-image",attrs:{"src":_vm.contactImage,"alt":"联系我们"}})]),_c('CallMe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }